import { z } from 'zod';

export const knowledgeBaseSchema = z.object({
  knowledgebase: z.object({
    name: z.string({ message: 'Email is required' })
  })
});
